import AccountTreeIcon from "@material-ui/icons/AccountTree";
import ProductList from "./ProductList";

export default {
  list: ProductList,
  icon: AccountTreeIcon,
};
